import $ from 'jquery'
import template from 'lodash.template'
import AjaxList from '../../components/ajaxList'
import i18n from '../../utils/translate'

class Module {
  constructor ($module) {
    this.$container = $module.find('.js-legal-entities_list')
    this.$list = $module.find('.js-legal-entities_wrap')
    this.$templateEl = $module.find('.js-legal-entities-template')
    this.template = template(this.$templateEl.html())

    this.list = new AjaxList({
      $container: this.$container,
      $form: $module.find('.js-legal-entities-form'),
      append: (response, replace) => {
        return this.append(response, replace)
      }
    })
  }

  append (response, replace) {
    const $content = $('<div>')

    response.entities.forEach((v) => {
      $content.append(this.render(v))
    })

    this.$list.empty()
    this.$list.append($content)
  }

  render (value) {
    const status = i18n.gettext('legal_entity.status_' + value.status)
    const newUrl = value.status === 'approved' ? this.$templateEl.data('new-url').replace('_entity_', value.id) : null
    const showUrl = value.status === 'approved' ? this.$templateEl.data('show-url').replace('_entity_', value.id) : null

    return this.template({
      name: value.details.name,
      status: status,
      newUrl: newUrl,
      showUrl: showUrl
    })
  }
}

$(function () {
  $('.js-legal-entities').each(function () {
    new Module($(this))
  })
})
